import { Outlet } from "react-router-dom";
import { LayoutDashboard, Briefcase, Users, Monitor, Bot, DollarSign, Globe } from "lucide-react";
import HubSidebar from "@/components/HubSidebar";

const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/smartpay/dashboard", description: "KPI overview & AI insights" },
  { id: "contractors", label: "Contractor Hub", icon: Briefcase, path: "/smartpay/contractors", description: "Contracts, timesheets & milestones" },
  { id: "hris", label: "HRIS Core", icon: Users, path: "/smartpay/hris", description: "Employees, onboarding & time tracking" },
  { id: "equipment", label: "Equipment", icon: Monitor, path: "/smartpay/equipment", description: "Devices, requests & lifecycle" },
  { id: "payroll", label: "Payroll", icon: DollarSign, path: "/smartpay/payroll", description: "Payroll processing & tax calculations" },
  { id: "eor", label: "EOR", icon: Globe, path: "/smartpay/eor", description: "Employer of Record & compliance" },
  { id: "assistant", label: "AI Assistant", icon: Bot, path: "/smartpay/assistant", description: "SmartPay AI copilot" },
];

export default function SmartPayLayout() {
  return (
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="AllBaise SmartPay"
        subtitle="Resource Management Hub"
        icon={LayoutDashboard}
        gradient="from-teal-500 to-cyan-600"
        activeBg="bg-teal-500"
      />
      <main className="flex-1 overflow-auto p-6"><Outlet /></main>
    </div>
  );
}
